import type { Primitive } from 'shared/lib/queryParams/common';

import type { Filters } from './common';
import { getPeriodTypeFromCode, isPresetPeriod } from './period';

export function filtersToUrlParams(filters: Partial<Filters>): Record<string, Primitive | Primitive[]> {
  const { date_from, date_to, period, cursor, ...rest } = filters;
  const urlParams: Record<string, Primitive | Primitive[]> = { ...rest };

  // Cleared by writing an empty string, which has no business being in the URL.
  if (cursor) {
    urlParams.cursor = cursor;
  }

  const periodType = getPeriodTypeFromCode(period ?? '');
  if (periodType && isPresetPeriod(periodType)) {
    urlParams.period = period;
  } else {
    if (date_from) {
      urlParams.date_from = date_from;
    }
    if (date_to) {
      urlParams.date_to = date_to;
    }
  }

  return urlParams;
}
